import { ImageCoords, LngLat } from '@features/map-layers-list/new-layer-file-uploader/model/types';

export function getCenter(coords: ImageCoords): LngLat {
    const lng = coords.reduce((s, c) => s + c[0], 0) / 4;
    const lat = coords.reduce((s, c) => s + c[1], 0) / 4;
    return [lng, lat];
}

export function rotateCoords(coords: ImageCoords, angle: number): ImageCoords {
    const [cx, cy] = getCenter(coords);

    return coords.map(([lng, lat]) => {
        const x = lng - cx;
        const y = lat - cy;

        return [
            cx + x * Math.cos(angle) - y * Math.sin(angle),
            cy + x * Math.sin(angle) + y * Math.cos(angle),
        ];
    }) as ImageCoords;
}

export function handlesGeoJSON(coords: ImageCoords): GeoJSON.FeatureCollection {
    return {
        type: 'FeatureCollection',
        features: coords.map((c, i) => ({
            type: 'Feature',
            properties: { index: i },
            geometry: {
                type: 'Point',
                coordinates: c,
            },
        })),
    };
}
